/**
 * Mirror of backend/utils/searchTerms.js parseSearchTerms.
 *
 * Splits a free-form search input into individual keywords using commas,
 * newlines, or " OR " (case-insensitive) as separators, so a pasted
 * LinkedIn boolean like:
 *   "Grid Connection" OR "Grid Integration" OR "Network Connection"
 * yields ["Grid Connection", "Grid Integration", "Network Connection"].
 *
 * Surrounding quotes and parentheses on each term are stripped.
 */
export function parseSearchTerms(search: string | null | undefined): string[] {
  if (!search || !search.trim()) return [];
  return search
    .split(/,|\n|\s+OR\s+/i)
    .map(t => t.trim().replace(/^["'(]+|["')]+$/g, '').trim())
    .filter(t => t.length > 0);
}
